// Prédicat de plateforme partagé.
//
// `Capacitor.isNativePlatform()` est appelé directement partout ailleurs dans le
// dépôt, sans protection. Ici on l'enveloppe, parce que les appelants de ce module
// sont sur le chemin de l'authentification : `authStorage.ts` est appelé par le SDK
// Supabase SANS try/catch, donc une exception qui remonterait casserait l'auth au
// lieu de dégrader vers le comportement web.
//
// Il vit dans son propre fichier plutôt que dans l'un des appelants pour que les
// tests puissent continuer à mocker la vraie frontière (`@capacitor/core`) même
// quand ils mockent l'un des modules d'auth en entier.

import { Capacitor } from '@capacitor/core';

/** Sommes-nous dans l'app native (iOS / Android) ? Ne jette jamais. */
export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
